import gql from "graphql-tag";

export const ASSIGN_ADVISOR_MUTATION = gql`
  mutation assignAdvisor(
    $testatorId: ID!
    $email: String!
    $sendEmail: Boolean
  ) {
    assignAdvisor(
      testatorId: $testatorId
      email: $email
      sendEmail: $sendEmail
    ) {
      id
      fullName
      email
      company {
        id
        tradingName
        executorship
        negotiableExecutorFee
        defaultExecutorFeePercentage
      }
    }
  }
`;

export const REMOVE_ADVISOR_MUTATION = gql`
  mutation removeAdvisor($testatorId: ID!, $sendEmailToAdvisor: Boolean) {
    removeAdvisor(
      testatorId: $testatorId
      sendEmailToAdvisor: $sendEmailToAdvisor
    ) {
      testator {
        id
        advisorId
        advisor {
          id
          fullName
        }
      }
    }
  }
`;

export const ADVISOR_MANAGED_TESTATORS_QUERY = gql`
  query User($id: ID!) {
    user(id: $id) {
      id
      managedTestators {
        id
        user {
          id
          fullName
          email
        }
      }
    }
  }
`;

export const ADVISOR_REQUEST_MUTATION = gql`
  mutation advisorRequest(
    $firstName: String!
    $lastName: String!
    $emailAddress: String!
    $cellNumber: String!
    $staffCode: String!
  ) {
    advisorRequest(
      firstName: $firstName
      lastName: $lastName
      emailAddress: $emailAddress
      cellNumber: $cellNumber
      staffCode: $staffCode
    ) {
      success
    }
  }
`;

export const REGISTER_ADVISER_MUTATION = gql`
  mutation registerAdviser(
    $firstNames: String!
    $lastName: String!
    $email: String!
    $adviserCode: String!
    $company: String!
    $password: String!
  ) {
    registerAdviser(
      firstNames: $firstNames
      lastName: $lastName
      email: $email
      adviserCode: $adviserCode
      company: $company
      password: $password
    ) {
      testatorId
      accessToken
      refreshToken
      userId
      belongsToCompany
      email
      phone
      uniqueIdentifier
      fullName
      advisorName
      advisorEmail
      companyName
      companyId
      companyLogoUrl
      willCountry
    }
  }
`;
